<template>
    <div class="addresses">
        <p-header title="常用地址"/>
        <div class="address">
            <address-item v-for="address in addresses" :address="address" :key="address.id" @click.native="setDefaultAddress(address.id)"/>
        </div>
        <router-link class="button" :to="{name: 'address'}">
            新增地址
        </router-link>
    </div>
</template>

<script>
    import Header from './components/Header';
    import AddressItem from './components/address/AddressItem';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Addresses',
        components: {
            'p-header': Header,
            'address-item': AddressItem,
        },
        computed: {
            ...mapGetters(['addresses'])
        },
        methods: {
            ...mapActions(['getAddresses', 'setDefaultAddress'])
        },
        created() {
            this.getAddresses();
        }
    };
</script>

<style lang="scss" scoped>
    .addresses {
        position: relative;
        flex: 1;
        padding-bottom: 65px;
        box-sizing: border-box;
    }

    .button {
        height: 45px;
        border-radius: 35px;
        background-color: #339933;
        margin: 10px 0;
        color: #FFFFFF;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        position: absolute;
        bottom: 0;
        left: 15px;
        right: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
    }
</style>
